import React, { useEffect } from "react";
import { Navigate } from "react-router-dom";
import { usePrivate } from "@/contexts/PrivateContext";

const Logout = () => {
  const priv = usePrivate();

  useEffect(() => {
    priv.logout();
  }, []);

  return <Navigate to="/login" />;
};

export default Logout;